import { Injectable } from '@angular/core';
import axiosClient from '../../../shared/axios/axios-client';
import { SnackbarService } from '../snackbar/snackbar.service';

export interface ModuloResponse {
  idModulo: number;
  nome: string;
  descricao: string;
  imagemUrl: string;
  ativo: boolean;
  idLinhaDeCuidado: number;
  linhaDeCuidadoNome: string;
}

export interface ModuloEmpresaResponse {
  idEmpresa: number;
  nomeFantasia: string;
  cnpj: string;
  estado: string;
  cidade: string;
}

export interface AtualizarModuloRequest {
  nome: string;
  descricao: string;
}

@Injectable({
  providedIn: 'root',
})
export class ModuloService {
  constructor(private readonly snackbarService: SnackbarService) {}

  // ── Módulo ────────────────────────────────────────────────

  async listarTodos(): Promise<ModuloResponse[]> {
    return await axiosClient
      .get('/modulo')
      .then((res) => res.data.data)
      .catch((err) => {
        this.snackbarService.error(err.response?.data?.message || err.message);
        throw err;
      });
  }

  async buscarPorId(id: number): Promise<ModuloResponse> {
    return await axiosClient
      .get(`/modulo/${id}`)
      .then((res) => res.data.data)
      .catch((err) => {
        this.snackbarService.error(err.response?.data?.message || err.message);
        throw err;
      });
  }

  async atualizar(id: number, dto: AtualizarModuloRequest): Promise<ModuloResponse> {
    return await axiosClient
      .put(`/modulo/${id}`, dto)
      .then((res) => res.data.data)
      .catch((err) => {
        this.snackbarService.error(err.response?.data?.message || err.message);
        throw err;
      });
  }

  async uploadImagem(id: number, arquivo: File): Promise<ModuloResponse> {
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    return await axiosClient
      .post(`/modulo/${id}/imagem`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((res) => res.data.data)
      .catch((err) => {
        this.snackbarService.error(err.response?.data?.message || err.message);
        throw err;
      });
  }

  // ── Empresas do módulo ────────────────────────────────────

  async listarEmpresas(id: number): Promise<ModuloEmpresaResponse[]> {
    return await axiosClient
      .get(`/modulo/${id}/empresas`)
      .then((res) => res.data.data)
      .catch((err) => {
        this.snackbarService.error(err.response?.data?.message || err.message);
        throw err;
      });
  }


  async listarEmpresasDisponiveis(id: number): Promise<ModuloEmpresaResponse[]> {
    return await axiosClient
      .get(`/modulo/${id}/empresas/disponiveis`)
      .then((res) => res.data.data)
      .catch((err) => {
        this.snackbarService.error(err.response?.data?.message || err.message);
        throw err;
      });
  }

  async adicionarEmpresas(id: number, idsEmpresas: number[]): Promise<void> {
    return await axiosClient
      .post(`/modulo/${id}/empresas`, idsEmpresas)
      .then(() => undefined)
      .catch((err) => {
        this.snackbarService.error(err.response?.data?.message || err.message);
        throw err;
      });
  }

  async removerEmpresa(id: number, idEmpresa: number): Promise<void> {
    return await axiosClient
      .delete(`/modulo/${id}/empresas/${idEmpresa}`)
      .then(() => undefined)
      .catch((err) => {
        this.snackbarService.error(err.response?.data?.message || err.message);
        throw err;
      });
  }
}